import { formatMemoDate } from "@/lib/format";
import type { MemoOrigin } from "@/lib/types";

/** Whether a row can carry a "came from Protokoll X" breadcrumb.
 *
 * ONLY top-level (`depth === 0`) to-dos on an Aufgaben board qualify — a
 * delegated SUB-TASK (depth > 0) never shows the breadcrumb, and its assignee
 * (a row-scoped guest, not a series participant) is deliberately not given a
 * path into the Protokoll. `raw.id` gates out an optimistic row with no real id
 * yet (nothing to resolve). Structural param types so the pure logic is
 * testable without building a full ViewRow/ViewBoard. */
export function memoOriginEligible(
  board: { is_aufgaben?: boolean },
  row: { raw?: { id?: string; depth?: number } | null },
): boolean {
  return Boolean(board.is_aufgaben) && (row.raw?.depth ?? 0) === 0 && Boolean(row.raw?.id);
}

/** `Serie · Datum · Abschnitt › Zwischenabschnitt` (the › segment only when the
 * to-do sits under a subheading). */
export function memoOriginLabel(origin: MemoOrigin): string {
  const head = `${origin.series_name} · ${formatMemoDate(origin.meeting_date)} · ${origin.block_title}`;
  return origin.subheading ? `${head} › ${origin.subheading}` : head;
}
